exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.padding {\n    padding: 1px !important;\n    vertical-align: middle !important;\n      height: 40px !important;\n}\ntd.id {\n    width: 40px;\n}\n\ninput.ng-touched.ng-invalid {border:solid red 2px;}\ninput.ng-touched.ng-valid {border:solid green 2px;}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/logistic/logistic_frontend/~/css-loader?{"sourceMap":false,"importLoaders":1}!/var/www/logistic/logistic_frontend/~/postcss-loader?{"ident":"postcss"}!/var/www/logistic/logistic_frontend/src/css/app.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/css/app.css
// module chunks = 8